import React from 'react';

export function ResultIcon({ show, product }) {
    if (!show || !product) return null;
    
    return (
        <div className="result-icon-overlay">
            <div className="result-icon-container">
                <div 
                    className="result-icon"
                    style={{
                        backgroundImage: `url('./images/SVG/${product.productIcon}.svg')`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                </div>
            </div>
        </div>
    );
}
